export default "__VITE_ASSET__DEYvHLBR__"